export class CreateOrdeService {
    constructor() {
        this.handle = async (data_) => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/orders/create`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data_),
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
